import { Badge } from '@mantine/core';
import type { EntityRegistryEntry, ColumnOptions } from '../types';
import type { TableColumn } from '../../components/common/GenericTable';

export const appRegistrationConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    listColumns: (options: ColumnOptions): TableColumn<any>[] => {
        const cols: TableColumn<any>[] = [
            {
                key: 'displayName',
                label: 'Name',
                title: 'DisplayName',
            },
            {
                key: 'clientId',
                label: 'Client ID',
                title: 'ClientId',
                render: (entity: any) => {
                    const val = entity?.ClientId || entity?.rawData?.ClientId || '';
                    return val ? val.substring(0, 24) + (val.length > 24 ? '…' : '') : null;
                },
            },
            {
                key: 'disabled',
                label: 'Status',
                title: 'Disabled',
                render: (entity: any) => {
                    const disabled = entity?.Disabled ?? entity?.rawData?.Disabled;
                    if (disabled === true) return Badge({ variant: 'filled', color: 'red', size: 'xs', children: 'Disabled' });
                    return Badge({ variant: 'filled', color: 'green', size: 'xs', children: 'Active' });
                },
            },
        ];

        if (!options.isStandard) {
            cols.push(
                {
                    key: 'isSystem',
                    label: 'System',
                    title: 'IsSystem',
                    render: (entity: any) => {
                        const val = entity?.IsSystem ?? entity?.rawData?.IsSystem;
                        if (val !== true) return null;
                        return Badge({ variant: 'outline', color: 'gray', size: 'xs', children: 'System' });
                    },
                },
                {
                    key: 'tenantId',
                    label: 'Tenant',
                    title: 'TenantId',
                    render: (entity: any) => {
                        const val = entity?.TenantId || entity?.rawData?.TenantId || '';
                        return val ? val.substring(0, 16) + '…' : null;
                    },
                },
            );
        }

        return cols;
    },
};
